<template>
  <div class="col-lg-3">
      <div class="widget style1">
            <div class="row">
                <div class="col-2 text-center">
                    <font-awesome-icon :icon="iconName" size="4x" />
                </div>
                <div class="col-10 text-right">
                    <span>{{caption}}</span>
                    <h2 class="font-bold">{{count}}</h2>
                </div>
            </div>
      </div>

  </div>
</template>

<script>

export default{
  name: 'StretchCardComponent',
  components: {
  },
  props: {
      count: Number,
      caption: String,
      iconName: String
  },
  data() {
    return {};
  },
  computed: {
  },
  mounted: function () {
    
  },
  methods: {

  }
}
</script>

<style>
  .font-bold{
      font-weight: 600;
  }

  .widget {
    border-radius: 5px;
    padding: 5px 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    background-color: #1ab394 !important;
    color: #ffffff;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/StretchCardCompoment.vue